import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { UPDATE_TAGGED_DATE_REQUEST } from "../types"
import { setNotification } from "../actions/notificationActions"
import { taggedDateServices } from "../services/tagged.date.services"
import { updateTaggedDateFailed, updateTaggedDateSuccess } from "../actions/taggedDateActions"

function* updateTaggedDateSaga(action) {
	try {
		const result = yield call(taggedDateServices?.updateTaggedDateAPI, action.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(updateTaggedDateSuccess({ ...result?.data, reqData: result?.config?.data && JSON.parse(result?.config?.data) }))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(updateTaggedDateFailed(result))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
		}
	} catch (error) {
		yield put(updateTaggedDateFailed(error))
	}
}

function* taggedDateWatcher() {
	yield takeLatest(UPDATE_TAGGED_DATE_REQUEST, updateTaggedDateSaga)
}

export default taggedDateWatcher
